import React from 'react';
import PropTypes from 'prop-types';
import useComContext from '../useComContext';

function AddToCart(props) {
  var _useComContext = useComContext(),
      AddToCartComponent = _useComContext.AddToCartComponent;

  return AddToCartComponent ? /*#__PURE__*/React.createElement(AddToCartComponent, props) : null;
}

AddToCart.propTypes = {
  cartSubject: PropTypes.shape({
    id: PropTypes.string.isRequired,
    product: PropTypes.shape({}).isRequired,
    quantity: PropTypes.number,
    quantityMax: PropTypes.number,
    quantityMin: PropTypes.number,
    quantityStep: PropTypes.number,
    quantityStepRounding: PropTypes.oneOf(['up', 'down'])
  }),
  classes: PropTypes.shape({
    disabled: PropTypes.string,
    input: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,

  /**
   * Prop specific for component addToCart
   *
   * props are sending to component you choose AddToCartButtonToQty, AddToCartInpButton, AddToCartInpToQty, AddToCartOnlyButton,
   * AddToCartQty, AddToCartQtyButton
   * */
  componentProps: PropTypes.shape({}),
  disabled: PropTypes.bool,
  forcePreventDecrement: PropTypes.bool,
  onAddToCart: PropTypes.func,
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    quantityMax: PropTypes.number,
    quantityMin: PropTypes.number,
    quantityStep: PropTypes.number,
    quantityStepRounding: PropTypes.oneOf(['up', 'down'])
  }),
  quantityMax: PropTypes.number,
  quantityMin: PropTypes.number,
  quantityStep: PropTypes.number,
  quantityStepRounding: PropTypes.oneOf(['up', 'down']),
  ruleCode: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
AddToCart.defaultProps = {
  cartSubject: undefined,
  classes: undefined,
  className: undefined,
  componentProps: undefined,
  disabled: false,
  forcePreventDecrement: true,
  onAddToCart: undefined,
  product: undefined,
  quantityMax: undefined,
  quantityMin: undefined,
  quantityStep: undefined,
  quantityStepRounding: undefined,
  ruleCode: undefined,
  size: 'medium'
};
export default AddToCart;